import React from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { View } from 'react-native';
import { LocStr } from '../../../utils/Utils';
import { getTooltipsTitleTag } from '../../../utils/DictionaryManagementUtils';
import PanelHeadlineContainer from '../Headline/PanelHeadlineContainer';
import EditTextElements from '../EditTextElements/EditTextElements';
import BreakLine from './BreakLine';
import StepIndicator from '../Headline/StepIndicator';

//= ========================================================================

const FullPagePanel = ({
  children,
  globJSON,
  onConfigChanged,
  editTextList,
  apiTextList,
  editTextListDefault,
  selectedScreen,
  language,
  onStepPressed,
  onGotoEdit,
  panelHeadline,
  panelSubHeadline,
  tooltipsTitles,
  paragraph,
  isHollow,
  disableEditElements,
  hideStepIndicator,
  breakLineMarginTop = 0,
  extraServiceLineHeight = 0,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const serviceLineHeight = 45;
  return (
    <ScrollView
      style={{
        paddingHorizontal: 50,
        paddingBottom: 160 + extraServiceLineHeight * serviceLineHeight,
      }}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >
      {(myScreen && !hideStepIndicator && (
        <StepIndicator
          language={language}
          onGotoEdit={onGotoEdit}
          myScreen={myScreen}
          onStepPressed={onStepPressed}
          titles={tooltipsTitles.map((tooltipsTitleTag) => getTooltipsTitleTag[tooltipsTitleTag])}
          isHollow={isHollow}
        />
      ))}
      {panelHeadline && (
      <PanelHeadlineContainer
        headline={LocStr(panelHeadline, language)}
        subheading={LocStr(panelSubHeadline, language)}
        paragraph={paragraph}
      />
      )}
      {children}
      {(editTextList && !disableEditElements)
            && (
            <View>
              <BreakLine marginTop={breakLineMarginTop} />
              <EditTextElements
                globJSON={globJSON}
                language={language}
                editTextList={editTextList}
                apiTextList={apiTextList}
                onConfigChanged={onConfigChanged}
                editTextListDefault={editTextListDefault}
              />
            </View>
            )}
    </ScrollView>
  );
};
export default FullPagePanel;
